import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import AddAttachmentModal from './add-attachment-modal';
import Loading from '../../../../shared/loading';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import { list, deleteById } from '../../../../services/wire/edit-attachment-services';

export default class AttachmentsControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      attachments: [],
    };
  }

  componentDidMount() {
    this.loading.start();
    list(this.props.wireId)
      .then(result => this.setState({ attachments: result.data.attachments }))
      .catch(e => defaultOnErrorHandler(e, 'Error getting attachments'))
      .finally(() => this.loading.stop());
  }

  handleAttachmentAdded(attachment) {
    this.setState(state => update(state, {
      attachments: {
        $push: [attachment],
      },
    }));
  }

  removeAttachment(e, attachment) {
    e && e.preventDefault && e.preventDefault();

    deleteById(this.props.wireId, attachment.id).then(() => this.setState(state => update(state, {
      attachments: attachments => attachments.filter(a => a.id !== attachment.id),
    })));
  }

  render() {
    return (
      <ErrorBoundary>
        <aside className="sidebar-item">
          <section className="form-group">
            <span className="sidebar-item-desc">Would you like to attach a document?</span>
            <a
              href="#"
              className="sidebar-item-link"
              onClick={e => this.addAttachmentModal.present(e)}
            >
              Attach
            </a>
            <Loading variant="inline" ref={el => (this.loading = el)}>
              {!!this.state.attachments.length || (
                <div className="clearfix" />
              )}
              {!!this.state.attachments.length && (
                <ul className="sidebar-item-list">
                  {this.state.attachments.map(a => (
                    <li key={a.id}>
                      <a
                        className="sidebar-item-attachment-name"
                        href={a.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {a.filename}
                      </a>
                      <a className="sidebar-item-link" href="#" onClick={e => this.removeAttachment(e, a)}>Remove</a>
                    </li>
                  ))}
                </ul>
              )}
            </Loading>
          </section>
        </aside>
        <AddAttachmentModal
          ref={c => (this.addAttachmentModal = c)}
          wireId={this.props.wireId}
          onAttachmentAdded={a => this.handleAttachmentAdded(a)}
        />
      </ErrorBoundary>
    );
  }
}
